import searchBarUrl from './search-bar.html';

export default {
  controllerAs: 'ctrl',
  bindings: {
    search: '&',
    placeholder: '@',
  },
  templateUrl: searchBarUrl,
};
